'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _instafeed = require('instafeed.js');

var _instafeed2 = _interopRequireDefault(_instafeed);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('template-blog-instagram', {
  onLoad: function onLoad() {
    var container = this.container;
    var feed = (0, _jquery2.default)(container).find('[data-instagram-feed]');
    var limit = feed.data('limit');
    var token = feed.data('token');
    var user = feed.data('user');
    var target = 'instagram_feed_' + (0, _jquery2.default)(feed).data('id');

    this.instagram = new _instafeed2.default({
      get: 'user',
      userId: user,
      accessToken: token,
      target: target,
      limit: limit,
      resolution: 'standard_resolution',
      template: '<div class="insta-gram column large--4 medium--4 small--6 padding-left-0x padding-right-0x vertical-center"><a class="block" href="{{link}}" target="_blank" rel="nofollow"><div class="background-image" data-ratio="1:1" style="background-image:url({{image}})"><img src="{{image}}" alt="{{caption}}"/></div></a></div>'
    });

    this.instagram.run();
  },
  onUnload: function onUnload() {}
});